import { useQuery } from '@tanstack/react-query';

import { useCurrentOrgId } from '@/features/org/hooks/use-current-org-id';
import { getAvailableProjectSubscriptions } from '@/features/subscriptions/api/get-available-project-subscription';

export const PROJECT_SUBSCRIPTION_QUERY_KEY = 'project-subscription';

export function useAvailableProjectSubscriptions() {
  const currentOrgId = useCurrentOrgId();

  return useQuery({
    queryKey: [PROJECT_SUBSCRIPTION_QUERY_KEY, currentOrgId],
    queryFn: () => getAvailableProjectSubscriptions(currentOrgId ?? 0),
    enabled: !!currentOrgId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
